import styled from 'styled-components';
import {Button} from '../../../ui/atoms/button';
import {
  getColorFromTheme,
  getFontSizeFromTheme,
  getLineHeightFromTheme,
} from '../../../ui/ui-utils';

export const ProfileContent = styled.div`
  width: 100%;
  margin: 0 auto;
`;

export const ProfileStack = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 24px;
`;

export const SettingsCard = styled.section`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 10px;
  background: ${getColorFromTheme('white')};
`;

export const ProfileSummaryCard = styled(SettingsCard)`
  display: flex;
  align-items: center;
  min-height: 128px;
  padding: 24px;
`;

export const ProfileSummary = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 24px;

  @media (max-width: 600px) {
    align-items: flex-start;
    gap: 18px;
  }
`;

export const ProfileAvatarEditor = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  flex: 0 0 80px;

  > div:first-child {
    width: 80px;
    height: 80px;
    overflow: hidden;
    border-radius: 50%;

    > div {
      transform: scale(0.8);
      transform-origin: top left;
    }
  }
`;

export const AvatarAction = styled(Button)`
  position: absolute;
  right: -2px;
  bottom: -8px;
  z-index: 1;
  min-width: 42px;
  height: 28px;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 18px;
`;

export const ProfileIdentity = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;

export const ProfileName = styled.h1`
  overflow: hidden;
  margin: 0;
  color: ${getColorFromTheme('blackTwo')};
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 600px) {
    font-size: 20px;
    line-height: 28px;
    white-space: normal;
  }
`;

export const ProfileRole = styled.span`
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 4px 12px;
  border-radius: 8px;
  color: ${getColorFromTheme('textBody')};
  background: ${getColorFromTheme('backgroundDark')};
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
`;

export const DetailsCard = styled(SettingsCard)`
  padding: 24px;

  @media (max-width: 600px) {
    padding: 20px 16px;
  }
`;

export const SectionIntro = styled.div`
  margin-bottom: 24px;

  h2 {
    margin: 0 0 4px;
    color: ${getColorFromTheme('blackTwo')};
    font-size: ${getFontSizeFromTheme('body1')};
    font-weight: 600;
    line-height: ${getLineHeightFromTheme('body1')};
  }

  p {
    margin: 0;
    color: ${getColorFromTheme('textBody')};
    font-size: ${getFontSizeFromTheme('body2')};
    line-height: ${getLineHeightFromTheme('body2')};
  }
`;

export const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px 24px;

  @media (max-width: 760px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const FieldCell = styled.div`
  min-width: 0;
`;

export const DetailsActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
`;

export const SecurityCard = styled(DetailsCard)`
  max-width: 100%;
`;

export const SecurityForm = styled.form`
  width: 100%;
  max-width: 456px;
`;

export const SecurityFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Wrapper = styled.div`
  width: 92%;

  @media (max-width: 500px) {
    width: 100%;
  }
`;

export const PageLayout = styled.section<any>`
  width: 100%;
  display: block;
  padding: 32px 69px 30px 32px;

  @media (max-width: 500px) {
    padding: 32px 12px 30px 12px;
  }
`;
export const ButtonWrapper = styled.span`
  float: right;
`;

export const RightWrapper = styled.div<any>`
  width: 100%;
  padding-bottom: 250px;

  @media (max-width: 900px) {
    margin-left: 0;
  }
`;

export const UserProfileWrapper = styled.div<any>`
  padding: 0 0 20px 0;
  border-bottom: 1px solid #ededf2;
`;

export const RightChildWrapper = styled.div<any>`
  display: flex;
  padding: 0 10px;
  margin-top: 24px;

  justify-content: space-between;
  flex-wrap: wrap;
`;
export const RightChildWrapperSecurity = styled.div<any>`
  width: 50%;

  @media (max-width: 500px) {
    width: 100%;
  }
`;

export const RightChildSpan = styled.span<any>`
  width: 49%;

  @media (max-width: 678px) {
    width: 100%;
  }
`;

export const LeftWrapper = styled.div<any>`
  position: relative;
  padding-top: 24px;

  @media (max-width: 900px) {
    // width: 100%;
    margin-bottom: 24px;
    padding-left: 16px;
  }
`;

export const LeftWrapperInnerChild = styled.div<any>`
  display: flex;
  align-items: center;
  position: relative;

  @media (max-width: 900px) {
    position: absolute;
    left: 40%;
    flex-direction: column;
    justify-content: center;
    align-items: unset;
  }

  @media (max-width: 600px) {
    position: absolute;
    left: 30%;
    flex-direction: column;
    justify-content: center;
    align-items: unset;
  }

  @media (max-width: 480px) {
    position: relative;
    left: 0%;
    flex-direction: column;
    justify-content: center;
    align-items: unset;
  }
`;

export const LeftChildSpan = styled.span<any>`
  font-size: 8px;

  position: absolute;
  bottom: -10%;
  right: 20%;

  @media (max-width: 900px) {
    text-align: center;
    margin: auto;
    margin-top: 8px;
  }

  @media (max-width: 500px) {
    bottom: -2%;
  }
`;

export const LeftChildInput = styled.input<any>`
  display: none;
`;

export const CancelButton = styled(Button)`
  padding: 0 7px 0 0;
  line-height: 1;
  color: red;
  &:not(:disabled):hover {
    color: red;
  }
  &:focus {
    outline: none;
    color: red;
  }
`;

export const EmailButton = styled(Button)`
  padding: 0 3px 0 0;
  line-height: 1;
  overflow: hidden;
`;

export const CustomButton = styled(Button)`
  white-space: normal;
  font-weight: 400;
`;

export const ProfileSaveChangesButton = styled(CustomButton)`
  min-height: 46px;
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;

  &:disabled:not([aria-busy='true']) {
    border-color: transparent;
    color: ${getColorFromTheme('textMuted')};
    background: ${getColorFromTheme('backgroundDark')};
  }
`;

export const ExternalLink = styled.a`
  font-weight: 500;
  font-size: 14px;
  color: #bfbfd4;
`;
